import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "toggle"]

  connect() {
    $(this.toggleTarget).on("change", () => {
      this.submitForm()
    })
    
    this.formTarget.addEventListener("turbo:submit-end", () => {
      this.handleSubmitEnd()
    })
  }

  disconnect() {
    $(this.toggleTarget).off("change")
  }

  submitForm() {    
    // Create FormData before enabled is toggled off
    const formData = new FormData(this.formTarget)
    this.setToggleEnabled(false)

    // Submit with preserved FormData
    fetch(this.formTarget.action, {
      method: this.formTarget.method || "POST",
      body: formData,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "text/vnd.turbo-stream.html"
      }
    }).then(response => {
      if (response.ok) {
        return response.text()
      }
      throw new Error(`HTTP ${response.status}: ${response.statusText}`)
    }).then(html => {
      // Handle turbo stream response because flash template is malformed
      if (html.includes("<turbo-stream")) {
        this.handleTurboResponseWithWorkAround(html)
      }
      this.handleSubmitEnd()
    }).catch(error => {
      console.error("Form submission error:", error)
      this.handleSubmitEnd()
    })
  }

  setToggleEnabled(enabled) {
    if (enabled) {
      $(this.toggleTarget).bootstrapToggle("enable")
    } else {
      $(this.toggleTarget).bootstrapToggle("disable")
    }
  }

  handleTurboResponseWithWorkAround(html) {
    // Clear existing flash messages before applying new ones
    const existingAlerts = document.querySelectorAll(".alert")
    existingAlerts.forEach(alert => alert.remove())
    
    // Apply the turbo stream
    Turbo.renderStreamMessage(html)
  }

  handleSubmitEnd() {
    this.setToggleEnabled(true)
  }
}
